/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Activity_Kind_PrepInputs */



/**
* | output |
* | --- |
* | "Preparation" |
*
* @param {Chat_Activity_Kind_PrepInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const chat_activity_kind_prep = /** @type {((inputs?: Chat_Activity_Kind_PrepInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Activity_Kind_PrepInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Voorbereiding")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparation")
	return /** @type {LocalizedString} */ ("Preparation")
});